import { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { transition, variants } from './variants';
import { useClickOutside } from '../../../../utils/hooks/useClickOutside';
import styles from './QRSortMenu.module.css';

export default function QRSortMenu(props) {
    
    const { filters, setFilters } = props;
    const { sortBy } = filters;
    const [ ref, open, setOpen ] = useClickOutside(false);

    const handleSort = (e) => {
        e.stopPropagation();
        const id = e.target.id.replace('type-','');
    
        setFilters(prev => ({ ...prev, page: 1, sortBy: id === prev.sortBy ? '' : id }));
    };

    const handleSortIconReturn = () => {
        switch (sortBy) {
            case 'newest':
                return <i className='fas fa-arrow-down-small-big' />;
            case 'oldest':
                return <i className='fas fa-arrow-down-big-small' />;
            case 'alpha-asc':
                return <i className='fas fa-arrow-down-a-z' />;
            case 'alpha-des':
                return <i className='fas fa-arrow-down-z-a' />;
            case 'link':
                return <i className='fas fa-link-simple' />;
            case 'pdf':
                return <i className='fas fa-file-pdf' />;
            case 'menu-pdf':
            case 'menu-link':
            case 'menu':
                return <i className='fas fa-fork-knife' />;
            case 'location':
                return <i className='fas fa-map-location' />;
            case 'microsite':
                return <i className='fas fa-square-list' />;
            case 'appointment':
                return <i className='fas fa-calendar-days' />;
            case 'tracker':
                return <i className='fas fa-clipboard-list-check' />;
            case 'asset':
                return <i className='fas fa-shelves' />;
            case 'survey':
                return <i className='far fa-square-poll-vertical' />;
            default:
                return <i className='fas fa-arrow-down-wide-short' />;
        };
    };

    // Submenu states
    const [ showSortSubmenu, setShowSortSubmenu] = useState(true);
    const [ showFilterSubmenu, setShowFilterSubmenu ] = useState(true);

    const handleSubMenus = (e) => {
        e.stopPropagation();
        const id = e.target.id;

        if (id === 'sort') {
            setShowSortSubmenu(prev => !prev);
        } else if (id === 'filter') {
            setShowFilterSubmenu(prev => !prev);
        };

        return;
    };

    return (
        <div className={styles.sortBtn} ref={ref} onClick={() => setOpen(prev => !prev)}>
            {handleSortIconReturn()}
            <AnimatePresence mode='wait'>
                {open && (
                    <motion.div
                        key='sort-menu'
                        className={styles.wrapper}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <div className={styles.container}>
                            <button id='sort' className={`${styles.menuBtn} ${showSortSubmenu ? styles.show : null}`} onClick={(e) => handleSubMenus(e)}>Sort <i className={`far fa-${showSortSubmenu ? 'minus' : 'plus'}`} /></button>
                            <motion.div 
                                className={styles.menu}
                                transition={transition}
                                variants={variants}
                                initial={false}
                                animate={showSortSubmenu ? 'show' : 'hide'}
                            >
                                <div id='newest' className={`${styles.menuOption} ${sortBy === 'newest' ? styles.active : null}`} onClick={e => handleSort(e)}>Newest</div>
                                <div id='oldest' className={`${styles.menuOption} ${sortBy === 'oldest' ? styles.active : null}`} onClick={e => handleSort(e)}>Oldest</div>
                                <div id='alpha-asc' className={`${styles.menuOption} ${sortBy === 'alpha-asc' ? styles.active : null}`} onClick={e => handleSort(e)}>Alphabetical Ascend</div>
                                <div id='alpha-des' className={`${styles.menuOption} ${sortBy === 'alpha-des' ? styles.active : null}`} onClick={e => handleSort(e)}>Alphabetical Descend</div>
                            </motion.div>
                            <button id='filter' className={`${styles.menuBtn} ${showFilterSubmenu ? styles.show : null}`} onClick={e => handleSubMenus(e)}>Filter (Type) <i className={`far fa-${showFilterSubmenu ? 'minus' : 'plus'}`} /></button>
                            <motion.div 
                                id='filter-options' 
                                className={styles.menu}
                                transition={transition}
                                variants={variants}
                                initial={false}
                                animate={showFilterSubmenu ? 'show' : 'hide'}
                            >
                                <div id='type-link' className={`${styles.menuOption} ${sortBy === 'link' ? styles.active : null}`} onClick={e => handleSort(e)}>Link</div>
                                <div id='type-pdf' className={`${styles.menuOption} ${sortBy === 'pdf' ? styles.active : null}`} onClick={e => handleSort(e)}>PDF</div>
                                <div id='type-menu' className={`${styles.menuOption} ${sortBy === 'menu' ? styles.active : null}`} onClick={e => handleSort(e)}>Menu</div>
                                <div id='type-location' className={`${styles.menuOption} ${sortBy === 'location' ? styles.active : null}`} onClick={e => handleSort(e)}>Location</div>
                                <div id='type-microsite' className={`${styles.menuOption} ${sortBy === 'microsite' ? styles.active : null}`} onClick={e => handleSort(e)}>Microsite</div>
                                <div id='type-appointment' className={`${styles.menuOption} ${sortBy === 'appointment' ? styles.active : null}`} onClick={e => handleSort(e)}>Appointment</div>
                                <div id='type-tracker' className={`${styles.menuOption} ${sortBy === 'tracker' ? styles.active : null}`} onClick={e => handleSort(e)}>Tracker</div>
                                <div id='type-asset' className={`${styles.menuOption} ${sortBy === 'asset' ? styles.active : null}`} onClick={e => handleSort(e)}>Liquid Label</div>
                                <div id='type-google-review' className={`${styles.menuOption} ${sortBy === 'google-review' ? styles.active : null}`} onClick={e => handleSort(e)}>Google Review</div>
                                <div id='type-survey' className={`${styles.menuOption} ${sortBy === 'survey' ? styles.active : null}`} onClick={e => handleSort(e)}>Liquid Feedback</div>
                            </motion.div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};